<div style="position: relative; min-height: 80vh">
  <router-outlet></router-outlet>
</div>
